import { ChangeDetectionStrategy, Component, ElementRef } from "@angular/core";
import { SmFormFieldBase } from "./sm-form-field-base.component";
import { SmFormService } from "../sm-form-service";
import { InfoStackRow } from "@Shared/Components/sm-info-stack/sm-info-stack.component";

@Component({
    standalone: false,
    selector: 'sm-form-field-select',
    templateUrl: './sm-form-field-select.component.html',
    outputs: ['onValueChanged', 'onFocusChanged'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
// Drop down selection
export class SmFormFieldSelectComponent extends SmFormFieldBase {

    constructor(protected service: SmFormService, protected element: ElementRef) {
        super(service, element);
    }

    getOptions(): string[] {
        return this.model.Options.Options;
    }

    // HTML collapses runs of spaces; keep one breakable space per gap and make only the extras non-breaking so text still wraps (PS-2145).
    preserveSpaces(value: string): string {
        return value.replace(/ {2,}/g, (match) => ' ' + '\u00A0'.repeat(match.length - 1));
    }

    // Read-only display also collapses consecutive spaces, so apply the same fix to the info stack text (PS-2145).
    public override getInfoStack(): InfoStackRow[] {
        const infoStack = super.getInfoStack();
        infoStack.forEach((row) =>
            row.InfoLines.forEach((line) => {
                if (line.MainText) {
                    line.MainText = this.preserveSpaces(line.MainText);
                }
            }),
        );
        return infoStack;
    }

    protected override putFocusIntoInput(): void {
        this.element.nativeElement.querySelector('select').focus()
    }
}